export enum ProgramBehaviour {
  UsingBodyTraceScale = 32,
  IncludeFinishedUsers = 64,
  Restartable = 8192,
  RetriggeringEnabled = 32768,
  showMaintenanceStatusInCarePortal = 65536
}
